import React from "react";
import axios from "axios";
import { Breadcrumbs } from "@material-tailwind/react";
import { Link, useNavigate } from "react-router-dom";
import { MdOutlineAddPhotoAlternate } from "react-icons/md";
import { GiSteeringWheel } from "react-icons/gi";
import { FaGasPump } from "react-icons/fa";
import { FaCar } from "react-icons/fa";
import { GiCarWheel } from "react-icons/gi";
import { RxDimensions } from "react-icons/rx";
import { WiSnowflakeCold } from "react-icons/wi";
import { MdOutlineWifi } from "react-icons/md";
import { SlScreenDesktop } from "react-icons/sl";
import { FaUser } from "react-icons/fa6";
import { GiMoneyStack } from "react-icons/gi";
import { MdOutlineRoomPreferences } from "react-icons/md";
import { AiOutlineEdit } from "react-icons/ai";
import { useState, useEffect } from "react";
import Loading from "../../../COMPONENTS/Loading/Loading";
import { GoArrowLeft } from "react-icons/go";
import { IoMdPin, IoIosMail } from "react-icons/io";
import SidebarTop from "../../SidebarTop";
import Voiture from "../../../../API/tourisme/location/index";
import { ToastContainer, toast } from "react-toastify";
import { CiCalendarDate } from "react-icons/ci";
import { MdOutlineHomeWork, MdOutlinePayment } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { styled } from "@mui/material/styles";
import { FedaCheckoutButton, FedaCheckoutContainer } from "fedapay-reactjs";
import { Button, Form } from "react-bootstrap";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { loadStripe } from "@stripe/stripe-js";
import { getPaymentStatus } from "../../../../API/stripe/StripeTranction";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import Create from "../../../../Payment/Create";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

// Clé publique Stripe
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function PaymentPopup({
  open,
  dollarP,
  user_Id,
  montant,
  email,
  onSuccess,
  userPrenom,
  userNom,
  formData,
  onClose,
}) {
  const [isDialogOpen, setIsDialogOpen] = useState(open);
  useEffect(() => {
    setIsDialogOpen(open);
  }, [open]);

  // useEffect(() => {
  //     setIsDialogOpen(open);
  // }, [open]);

  const handleOpenAZ = () => {
    //alert("AZPay")
    // axios.get('/api/payment/create', {
    //     params: {
    //         provider: 'AZPay',
    //         item_id: 'item_id',
    //         item_name: 'item',
    //         amount: montant, // Assurez-vous de convertir les devises correctement
    //         currency: 'XOF',
    //         email: email,
    //         description: 'Publicité sur Mon Bon Sejour',
    //         phone: tel,
    //         email: email,
    //         last_name: userNom,  // Remplacez par les informations du client
    //         first_name: userPrenom,
    //         success_url: 'successUrl',
    //         customer_number: userId
    //     }
    // }).then(response => {
    //     if (response.data.fail) {
    //         if (response.data.type_error === "balance_insufficient") {
    //             //setError("Votre solde est insuffisant pour effectuer cette transaction.");
    //         }
    //     } else if (response.data.success_url) {
    //         window.location.href = response.data.success_url;
    //     } else {
    //         //setError("Une erreur s’est produite, veuillez réessayer !");
    //     }
    // }).catch(error => {
    //     console.error("Erreur lors de la requête AZPay :", error);
    // });
  };

  const handleClose = () => {
    setIsDialogOpen(false);
    if (onClose) onClose();
  };

  const handlePayCancel = () => {
    //console.log('Paiement annulé');
    handleClose();
  };
  const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY;
  const checkoutButtonOptions = {
    public_key: PUBLIC_KEY,
    transaction: {
      amount: montant,
      description: "Publicité sur Mon Bon Sejour",
      callback_url:
        "Dashboard/Publications/Location_Vehicule/Ajouter_les_vehicules",
      custom_metadata: {
        user_id: user_Id,
        //additional_info: 'Some additional info'
      },
    },
    currency: {
      iso: "XOF",
    },
    customer: {
      lastname: userNom,
      firstname: userPrenom,
      email: email,
    },
    button: {
      class: "btn btn-primary",
      text: "Payer " + montant + " FCFA",
    },
    onComplete(resp) {
      const FedaPay = window["FedaPay"];
      if (resp.reason === FedaPay.DIALOG_DISMISSED) {
        //window.location.reload();
        toast.success("Vous avez fermé la boite de dialogue");
      } else {
        setIsDialogOpen(false);
        onSuccess();
        localStorage.setItem('paiementId',resp.transaction.id)
        localStorage.setItem('provider',2)

        // Extraire les données de la transaction
        // const transactionData = {
        //   transaction_id: resp.transaction.id,
        //   reference: resp.transaction.reference,
        //   amount: resp.transaction.amount,
        //   description: resp.transaction.description,
        //   status: resp.transaction.status,
        //   approved_at: resp.transaction.approved_at,
        //   customer: {
        //     firstname: resp.transaction.customer.firstname,
        //     lastname: resp.transaction.customer.lastname,
        //     email: resp.transaction.customer.email,
        //   },
        //   transaction_key: resp.transaction.transaction_key,
        //   fees: resp.transaction.fees,
        //   mode: resp.transaction.mode,
        //   amount_debited: resp.transaction.amount_debited,
        //   custom_metadata:resp.transaction.custom_metadata.user_id,
        // };

        // // Envoie les données de la transaction au backend
        // fetch(`${process.env.REACT_APP_BASE_URL}/api/fedapay/callback`, {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //     'Accept': 'application/json'
        //   },
        //   body: JSON.stringify(transactionData),
        // })
        // .then(response => {
        //   if (!response.ok) {
        //     return response.json().then(errorData => {
        //       throw new Error(errorData.message || 'Something went wrong');
        //     });
        //   }
        //   return response.json();
        // })
        // .then(data => {
        //   console.log('Transaction saved:', data);
        // })
        // .catch((error) => {
        //   console.error('Error:', error);
        // });
      }

    },
    onCancel: handlePayCancel,
  };

  // Lancer le paiement FedaPay
  const handlePayment = () => {
    const FedaPay = window["FedaPay"];
    FedaPay.init(checkoutButtonOptions).open();
  };

  //stripe
  const createPaymentSession = async () => {
    try {
      const successUrl = `${window.location.origin}/Dashboard/Publications/Location_Vehicule/Ajouter_les_vehicules`;
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/payment/stripe`,
        {
          provider: "stripe",
          item_id: "item_id",
          item_name: "item",
          amount: Math.round((montant / dollarP) * 100),
          currency: "XOF",
          email: email,
          description: "Publicité sur Mon Bon Sejour",
          last_name: userNom,
          first_name: userPrenom,
          success_url: successUrl,
          customer_number: 1,
        }
      );

      if (response.data) {
        localStorage.setItem("sessionId", response.data.sessionId);
        return response.data.sessionId;
      } else {
        console.error(
          "Erreur lors de la création de la session de paiement :",
          response.data
        );
      }
    } catch (error) {
      console.error("Erreur lors de la requête Card :", error);
    }
  };

  const handleStripePayment = async () => {
    const sessionId = await createPaymentSession();
    if (sessionId) {
      const stripe = await stripePromise;
      //console.log(sessionId)

      const { error } = await stripe.redirectToCheckout({
        sessionId: sessionId,
      });

      if (error) {
        console.error("Erreur lors de la redirection vers Stripe :", error);
      } else {
        // Paiement réussi, appel de la fonction onSuccess
        //onSuccessStripe();
      }
    }
  };

  return (
    <BootstrapDialog 
             onClose={handleClose} 
             aria-labelledby="customized-dialog-title" 
             open={isDialogOpen}
           >
             <DialogTitle 
               sx={{ 
                 m: 0, 
                 p: 2, 
                 display: 'flex', 
                 alignItems: 'center', 
                 justifyContent: 'space-between' 
               }} 
               id="customized-dialog-title" 
               className='text-[#FE7F2D]'
             >
               <span className="flex items-center space-x-3">
                 <p>Veuillez choisir le mode de paiement</p>
               </span>
               <IconButton 
                 aria-label="close" 
                 onClick={handleClose}
                 sx={{
                   color: (theme) => theme.palette.grey[500],
                 }}
               >
                 <CloseIcon />
               </IconButton>
             </DialogTitle>
           
             <DialogContent dividers>
               <DialogActions
                 style={{
                   display: 'flex',
                   flexDirection: 'column',
                   width: '100%',
                   alignItems: 'center',
                   gap: '10px' // Remplace marginBottom pour un espacement plus uniforme
                 }}
               >
                 {[
                   {
                     onClick: handleOpenAZ,
                     label: `AZ-PAY : ${montant} F CFA`
                   },
                   {
                     onClick: handleStripePayment,
                     label: `Carte bancaire : ${montant} F CFA`
                   },
                   {
                     onClick: handlePayment,
                     label: checkoutButtonOptions.button.text
                   }
                 ].map((buttonConfig, index) => (
                   <Button
                     key={index}
                     onClick={buttonConfig.onClick}
                     style={{
                       textTransform: 'none',
                       backgroundColor: '#233D4D',
                       color: 'white',
                       width: '100%',
                       display: 'flex',
                       justifyContent: 'center',
                       alignItems: 'center',
                       padding: '10px', // Ajout de padding pour une meilleure apparence
                       marginLeft: '10px', // Ajout de padding pour une meilleure apparence
                     }}
                   >
                     {buttonConfig.label}
                   </Button>
                 ))}
               </DialogActions>
             </DialogContent>
     </BootstrapDialog>
  );
}

function AjoutVehicule() {
  localStorage.setItem(
    "url",
    JSON.stringify(
      "/Dashboard/Publications/Location_Vehicule/Ajouter_les_vehicules"
    )
  );

  const [data, setData] = useState(() => {
    // getting stored value
    const saved = localStorage.getItem("data");
    const initialValue = saved !== null ? JSON.parse(saved) : null;
    return initialValue;
  });

  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [address, setAddress] = useState([]);
  const [pricePub, setPricePub] = useState([]);
  const [priceD, setPriceD] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open,setOpen] = useState(false);
  const [options, setOptions] = useState(null);
  const [curr,setCurr] = useState();

  const [formData, setFormData] = useState(
    JSON.parse(localStorage.getItem("formData")) || {}
  );

  useEffect(() => {
    if (data !== null) {
      //adresse
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/api/utilisateur/adresse/${data.azId}`
        )
        .then((response) => {
          setAddress(response.data.data);
        })
        .catch((err) => console.log(err));
    } else {
      return navigate("/Connexion");
    }
  }, [data?.azId]);

  useEffect(() => {
    if (address && address.Adresses) {
      fd.append("adresse", address.Adresses);
    }
  }, [address]);

  let fd = new FormData();

  const [brand, setBrand] = useState([]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });

    // Enregistrez l'état du formulaire dans le stockage local
    localStorage.setItem(
      "formData",
      JSON.stringify({ ...formData, [event.target.name]: event.target.value })
    );
  };

  const handleCountryChange = (selectedOption) => {
    localStorage.setItem("code", selectedOption.value);

    setFormData({ ...formData, pays: selectedOption.value });
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/api/province/list/${selectedOption.value}`
      )
      .then((response) => {
        console.log(response.data.data);
        setProvinces(response.data.data);
      })
      .catch((err) => console.log(err));
  };

  const handleProvinceChange = (selectedProvince) => {
    // console.log(selectedProvince)
    //const { value } = selectedProvince.value;
    localStorage.setItem("province", selectedProvince.value);
    setFormData({ ...formData, province: selectedProvince.value });
    console.log(selectedProvince.value);

    // city
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/api/city/list/${selectedProvince.value}`
      )
      .then((response) => {
        console.log(response.data.data);
        setCities(response.data.data);
      })
      .catch((err) => console.log(err));
  };

  const handleCityChange = (selectedCity) => {
    localStorage.setItem("ville", selectedCity.value);
    setFormData({ ...formData, ville: selectedCity.value });
  };
  //Récuppérer le prix de publication
  const getPricePub = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/prix/pub/location`
      );
      //console.log(res.data.data.Prices,);
      localStorage.setItem("pricePub", res.data.data.Prices);
      setPricePub(res.data.data.Prices);
    } catch (err) {
      console.log(err);
    }
  };

  const getPriceDollar = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/prix/dollar`
      );
      //console.log(res.data.data.value_to_xof);
      setPriceD(res.data.data.value_to_xof);
    } catch (err) {
      console.log(err);
    }
  };

  const navigate = useNavigate();

  // États pour gérer le formulaire et le popup
  const [showPopup, setShowPopup] = useState(false);
  const [errors, setErrors] = useState({});

  let totalPaid =
    parseFloat(pricePub) *
    Math.ceil(
      (new Date(formData.date_fin) - new Date(formData.date_debut)) /
        (1000 * 60 * 60 * 24)
    );

   if(totalPaid > 0)
    {
        localStorage.setItem('montant',totalPaid)
    }

  const verifyLocationSubmitForm = async () => {
    fd.append("user", data.userId);
    fd.append("nom", formData.name_voiture ? formData.name_voiture : "");
    fd.append("type", formData.type ? formData.type : "");
    fd.append(
      "consommation",
      formData.consommation ? formData.consommation : ""
    );
    fd.append(
      "transmission",
      formData.transmission ? formData.transmission : ""
    );
    fd.append("methode", formData.methode ? formData.methode : "");
    fd.append("date", formData.date ? formData.date : "");
    fd.append("adresse", formData.lieu ? formData.lieu : address.Adresses);
    fd.append("size", formData.km ? formData.km : "");
    fd.append("camera", formData.TV ? formData.TV : "");
    fd.append("clim", formData.climatiseur ? formData.climatiseur : "");
    fd.append("desc", formData.msg ? formData.msg : "");
    fd.append("place", formData.nbre ? formData.nbre : "");
    fd.append("prix", formData.prix ? formData.prix : "");
    fd.append("wifi", formData.wifi ? formData.wifi : "");
    fd.append("puissance", formData.chevaux ? formData.chevaux : "");
    fd.append("date_debut", formData.date_debut ? formData.date_debut : "");
    fd.append("date_fin", formData.date_fin ? formData.date_fin : "");

    fd.append("tel", formData.phone ? formData.phone : data.userTel);
    fd.append("mail", formData.mail ? formData.mail : data.userMail);
    fd.append("pays", formData.country ? formData.country : "");
    fd.append("ville", formData.ville ? formData.ville : "");
    fd.append("province", formData.province ? formData.province : "");
    for (let i = 0; i < document.getElementById("image")?.files.length; i++) {
      fd.append("photo[]", document.getElementById("image")?.files[i]);
    }

    Voiture.verifyLocationForm(fd)
      .then((res) => {
        if (res.data.status === 422) {
          console.log(res.data.errors);
          setErrors(res.data.errors);
          setOpen(false)
        } else {
          if (totalPaid === 0) {
            submitForm();
            navigate(
              "/Dashboard/Publications/Location_Vehicule/Voir_les_vehicules"
            );
          }
         setOpen(true)
        }
      })
      .catch((err) => {
        console.log("Erreur lors de l'appel a l'API ", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const submitForm = (provider,paymentId,currencyId) => {
    //event.preventDefault();
    const pricePubFromStorage = localStorage.getItem("pricePub");

    //let fd = new FormData();

    fd.append("user", data.userId);
    fd.append("nom", formData.name_voiture ? formData.name_voiture : "");
    fd.append("type", formData.type ? formData.type : "");
    fd.append(
      "consommation",
      formData.consommation ? formData.consommation : ""
    );
    fd.append(
      "transmission",
      formData.transmission ? formData.transmission : ""
    );
    fd.append("methode", formData.methode ? formData.methode : "");
    fd.append("date", formData.date ? formData.date : "");
    fd.append("adresse", formData.lieu ? formData.lieu : address.Adresses);
    fd.append("size", formData.km ? formData.km : "");
    fd.append("camera", formData.TV ? formData.TV : "");
    fd.append("clim", formData.climatiseur ? formData.climatiseur : "");
    fd.append("desc", formData.msg ? formData.msg : "");
    fd.append("place", formData.nbre ? formData.nbre : "");
    fd.append("prix", formData.prix ? formData.prix : "");
    fd.append("wifi", formData.wifi ? formData.wifi : "");
    fd.append("puissance", formData.chevaux ? formData.chevaux : "");
    fd.append("date_debut", formData.date_debut ? formData.date_debut : "");
    fd.append("date_fin", formData.date_fin ? formData.date_fin : "");

    fd.append("tel", formData.phone ? formData.phone : data.userTel);
    fd.append("mail", formData.mail ? formData.mail : data.userMail);
    fd.append("pays", formData.country ? formData.country : "");
    fd.append("ville", formData.ville ? formData.ville : "");
    fd.append("province", formData.province ? formData.province : "");

    if (formData.date_debut && pricePubFromStorage && formData.date_fin) {
      const days = Math.ceil(
        (new Date(formData.date_fin) - new Date(formData.date_debut)) /
          (1000 * 60 * 60 * 24)
      );
      const montant = parseFloat(pricePubFromStorage) * days;
      fd.append("montant", montant);
      console.log("Calculated montant:", montant);
    } else {
      toast.error("Veuillez remplir tous les champs");
      return;
    }

    for (let i = 0; i < document.getElementById("image")?.files.length; i++) {
      fd.append("photo[]", document.getElementById("image")?.files[i]);
    }

    setLoading(true);
    Voiture.submitForm(fd)
      .then((res) => {
        if (res.data.status === 201) {
          if(provider !== null && paymentId !== null && currencyId !== null){
                    const formD = {
                            userId:data.azId,
                            montant:totalPaid,
                            provider: provider,
                            payement_id:paymentId ,
                            currency:currencyId,
                            annonce_number: res.data.announce_number,
                            description:"Transaction d'ajout  d'un vehicule"
                        }
                    axios.post(`${process.env.REACT_APP_BASE_URL}/api/store/rechargement-paiememnt`,formD)
                        .then((res)=>{
                        if(res.data.status === 200){
                        //toast.success(res.data.message);
                        //console.log("enregistrement reussie")
                        }
                        }).catch((err)=>{
                        console.log("Erreur lors de l'appel a l'API ",err)
                        })
            }
          //toast.success(res.data.message);
          localStorage.removeItem("formData");
          localStorage.removeItem("pricePub");
          localStorage.removeItem("province");
          localStorage.removeItem("ville");
          localStorage.setItem('idannonce',res.data.announce_number)
          localStorage.setItem("message", res.data.message);
          setErrors({});
          navigate(
            "/Dashboard/Publications/Location_Vehicule/Voir_les_vehicules"
          );
        } else {
          toast.error(res.data.message);
          //console.log(res);
        }
      })
      .catch((err) => {
        toast.error("Erreur merci de reessayer !");
        //console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Fonction de gestion de la soumission du formulaire
  const handleSubmit = (event) => {
    event.preventDefault();
    verifyLocationSubmitForm();
  };


  const handlePopupStripeSuccess = () => {
    submitForm();
    localStorage.removeItem("formData");
    localStorage.removeItem("pricePub");
  };

  useEffect(() => {
    if (!data) {
      navigate("/Connexion");
      return;
    }

     // Appel API pour récupérer la monnaie
            axios
            .get(`${process.env.REACT_APP_BASE_URL}/api/get/info/website`)
            .then((res) => {
            if (res.data.status === 200 ) {
                setCurr(res.data.currency);
                localStorage.setItem('id_currency', res.data.currency.id_currency);
            } else {
                console.warn("Réponse inattendue de l'API :", res.data);
            }
            })
            .catch((err) => {
            console.error("Erreur lors de l'appel à l'API :", err);
            });

    getPriceDollar();
    getPricePub();

    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/brand/all/`)
      .then((response) => {
        setBrand(response.data.data);
      })
      //.then(response => console.log(response))
      .catch((err) => console.log(err));

    //country
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/country/list`)
      .then((response) => {
        setCountries(response.data.data);
      })
      //.then(response => console.log(response.data.data))
      .catch((err) => console.log(err));

    //adresse
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/api/utilisateur/adresse/${data.azId}`
      )
      .then((response) => {
        setAddress(response.data.data);
        //console.log(response);
      })
      .catch((err) => console.log(err));

    const sessionId = localStorage.getItem("sessionId");
    if (sessionId) {
      getPaymentStatus(sessionId)
        .then((response) => {
          //console.log(response.data)
          if (response.data.status === "succeeded") {
            handlePopupStripeSuccess();
          }
        })
        .catch((error) => {
          console.error(
            "Erreur lors de la récupération du statut de paiement:",
            error
          );
        });
    }
    localStorage.removeItem("sessionId");

    const timer = setTimeout(() => {
      // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
      setLoading(false);
    }, 2000); // 5000 millisecondes = 5 secondes

    // Nettoyer le timer si le composant est démonté avant la fin du délai
    return () => clearTimeout(timer);
  }, []);


  let savedCode = localStorage.getItem("code")
    ? localStorage.getItem("code")
    : localStorage.getItem("is_code");
  let savedProvince = localStorage.getItem("province");
  let savedVille = localStorage.getItem("ville");

   useEffect(() => {
              if (curr) {
          
                setOptions({
                  id_currency: curr.id_currency,
                  success_url: window.location.origin ,
                  cancel_url: window.location.href,
                  amount:totalPaid,
                  customer: {
                    id: data.azId,
                    first_name: data.userLastname ?? '',
                    last_name: data.userName ?? '',
                    email: data.userMail,
                    phone: data.userTel,
                    code_country: 'BJ'
                  },
                  seller_number: 1
                });
              }
   }, [curr, totalPaid]);

  useEffect(() => {
    if (savedCode) {
      // setCode(savedCode);
      setFormData({
        ...formData,
        country: savedCode,
        province: savedProvince,
        ville: savedVille,
        climatiseur: "1",
        wifi: "1",
        TV: "1",
      });
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/api/province/list/${savedCode}`)
        .then((response) => {
          setProvinces(response.data.data);
        })
        .catch((err) => console.log(err));

      axios
        .get(`${process.env.REACT_APP_BASE_URL}/api/city/list/${savedProvince}`)
        .then((response) => {
          setCities(response.data.data);
        })
        .catch((err) => console.log(err));
    }
  }, [savedCode,savedProvince,savedVille]);

   useEffect(()=>{
            localStorage.removeItem('formData');
    },[])

   const today = new Date().toISOString().split("T")[0];
   const {t} = useTranslation()
   const lang = localStorage.getItem("langague");

  return (
    <div className="flex flex-row bg-[#eeee]">
      {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>
          <div className="w-screen h-screen barre_scroll">
            {/* navbar top orange */}
            <SidebarTop />
            {/* navbar top gris*/}
            <div className="bg-[#f7f7f7] sm:h-10 s:h-14 mt-[50px]">
              <Breadcrumbs>
                <Link to="" className="opacity-60 md:text-base s:text-xs">
                  {t("Mes publications")}
                </Link>
                <Link
                  to="/Dashboard/Publications/Location_Vehicule/Voir_les_vehicules"
                  className="opacity-60 md:text-base s:text-xs"
                >
                  {t("Location de vehicule")}
                </Link>
                <Link to="" className="md:text-base s:text-xs">
                  {t("Ajouter")}
                </Link>
              </Breadcrumbs>
            </div>

            <div>
              <ToastContainer />
            </div>

            <Link to="/Dashboard/Publications/Location_Vehicule/Voir_les_vehicules">
              <div className="flex flex-row items-center space-x-2 relative top-8 s:left-5 sm:left-12 w-[280px]">
                <GoArrowLeft className="text-[#fe7f2d]  text-lg" />
                <p>{t("Retour à la page précedente")}</p>
              </div>
            </Link>
            {/* container formulaire */}
            <div className="flex justify-center py-20 ">
              <form
                onSubmit={handleSubmit}
                className="flex flex-col space-y-3 "
              >
                <div className="bg-white s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px] rounded-md border-b-8  shadow flex flex-col space-y-6 ">
                  {/* Ajout des images */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlineAddPhotoAlternate className="text-xl text-[#fe7f2d]" />
                      <label>
                        {" "}
                        {t("Ajouter des images du vehicule")}{" "}
                        <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <input
                      type="file"
                      onChange={handleInputChange}
                      accept="image/*"
                      multiple
                      name="image"
                      id="image"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 "
                    />
                    {errors.photo && (
                      <p className="text-red-500">{errors.photo}</p>
                    )}
                  </div>
                  {/* Nom du vehicule */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <FaCar className="text-xl text-[#fe7f2d]" />
                      <label>
                        {t("Nom du vehicule")} <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <input
                      type="text"
                      onChange={handleInputChange}
                      name="name_voiture"
                      placeholder="Ex : Toyota gris "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.nom && <p className="text-red-500">{errors.nom}</p>}
                  </div>
                  {/* Marque du vehicule */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <GiSteeringWheel className="text-xl text-[#fe7f2d]" />
                      <label>
                        {t("Marque du vehicule")}{" "}
                        <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <select
                      onChange={handleInputChange}
                      name="type"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value=""></option>
                      {brand.map((option, index) => (
                        <option key={index} value={option.id}>
                          {option.brand}
                        </option>
                      ))}
                    </select>
                    {errors.type && (
                      <p className="text-red-500">{errors.type}</p>
                    )}
                  </div>
                  {/* Type de consommation */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <FaGasPump className="text-xl text-[#fe7f2d]" />
                      <label>
                        {t("Type de consommation")}{" "}
                        <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <select
                      onChange={handleInputChange}
                      name="consommation"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value=""></option>
                      <option value="diesel">Diesel</option>
                      <option value="essence">{t("Essence")}</option>
                      <option value="electrique">{t("Electrique")}</option>
                    </select>
                    {errors.consommation && (
                      <p className="text-red-500">{errors.consommation}</p>
                    )}
                  </div>
                  {/* Transmission automobile */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <GiCarWheel className="text-xl text-[#fe7f2d]" />
                      <label>
                        {t("Transmission automobile")}{" "}
                        <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <select
                      onChange={handleInputChange}
                      name="transmission"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value=""></option>
                      <option value="automatic">{t("Automatique")}</option>
                      <option value="manual">{t("Manuel")}</option>
                      <option value="hybrid">{t("Hybride")}</option>
                    </select>
                    {errors.transmission && (
                      <p className="text-red-500">{errors.transmission}</p>
                    )}
                  </div>
                  {/* Type de paiement */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlinePayment className="text-xl text-[#fe7f2d]" />
                      <label>
                        {t("Méthode de paiement")}{" "}
                        <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <select
                      onChange={handleInputChange}
                      name="methode"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value=""></option>
                      <option value="1">{t("Paiement en ligne et sur place")}</option>
                      <option value="2">{t("Paiement en ligne")}</option>
                      <option value="3">{t("Paiement sur place")}</option>
                    </select>
                    {errors.methode && (
                      <p className="text-red-500">{errors.methode}</p>
                    )}
                  </div>
                </div>

                <div className="bg-white  s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px]  rounded-md border-b-8  shadow flex flex-col space-y-6 ">
                  {/* Tel */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <FaPhoneAlt className=" text-[#fe7f2d]" />
                      <label>
                        {t("Telephone")} <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <input
                      type="tel"
                      name="phone"
                      defaultValue={data.userTel}
                      onChange={handleInputChange}
                      placeholder="Ex : +225 xxx xxx xxxx "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.tel && <p className="text-red-500">{errors.tel}</p>}
                  </div>
                  {/* Mail */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoIosMail className=" text-[#fe7f2d]" />
                      <label>
                        {t("Adresse e-mail")} <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <input
                      defaultValue={data.userMail}
                      type="email"
                      name="mail"
                      onChange={handleInputChange}
                      placeholder="Ex : info@monbonsejour.com "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.mail && (
                      <p className="text-red-500">{errors.mail}</p>
                    )}
                  </div>
                  {/* Country */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>
                       {t(" Pays")} <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <Form.Group>
                      <Select
                        onChange={handleCountryChange}
                        name="country"
                        value={
                          savedCode
                            ? {
                                label: lang === 'fr' ? countries.find((pay) => pay?.code === savedCode)?.fr_Name 
                                : countries.find((pay) => pay?.code === savedCode)?.Name ,
                                value: savedCode,
                              }
                            : null
                        } // Inclut la propriété value
                        options={countries.map((pay) => ({
                          label: lang === 'fr' ? pay?.fr_Name : pay?.Name,
                          value: pay?.code,
                        }))}
                        className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                      />
                    </Form.Group>
                    {/* <select onChange={handleCountryChange}  name='country' className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4'>
                                        <option value={address.code}>{address.fr_Name}</option>
                                                            {countries.map((option, index) => (
                                        <option key={index} value={option.code}>{option.fr_Name}</option>
                                        ))}
                                    </select> */}
                    {errors.pays && (
                      <p className="text-red-500">{errors.pays}</p>
                    )}
                  </div>
                  {/* Province */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>
                        {t("Province")} <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <Form.Group>
                      <Select
                        onChange={handleProvinceChange}
                        name="province"
                        value={
                          savedProvince
                            ? {
                                label: lang === 'fr' ? provinces.find((prov) =>prov?.code_province === savedProvince)?.fr_Name
                                : provinces.find((prov) =>prov?.code_province === savedProvince)?.Name,
                                value:  savedProvince,
                              }
                            : null
                        } // Inclut la propriété value
                        options={provinces.map((prov) => ({
                          label: lang === 'fr' ? prov?.fr_Name : prov?.Name ,
                          value: prov?.code_province,
                        }))}
                        className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                      />
                    </Form.Group>
                    {/* <select onChange={handleProvinceChange}  name='province' className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4'>
                                    <option value={address.code_province}>{address.pname}</option>
                                                        {provinces.map((option, index) => (
                                        <option key={index} value={option.code_province}>{option.fr_Name}</option>
                                        ))}
                                    </select> */}
                    {errors.province && (
                      <p className="text-red-500">{errors.province}</p>
                    )}
                  </div>
                  {/* Ville */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>
                        {t("Ville")} <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <Form.Group>
                      <Select
                        onChange={handleCityChange}
                        name="ville"
                        value={ savedVille
                            ? {label: lang === 'fr' ? cities.find((city) =>city?.code_city === savedVille)?.fr_Name 
                              : cities.find((city) =>city?.code_city === savedVille)?.Name ,
                                value: savedVille,
                              }
                            : null
                        } // Inclut la propriété value
                        options={cities.map((city) => ({
                          label: lang === 'fr' ? city?.fr_Name : city?.Name,
                          value: city?.code_city,
                        }))}
                        className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                      />
                    </Form.Group>
                    {/* <select onChange={handleInputChange}  name='ville' className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4'>
                                        <option value={address.code_city}>{address.cname}</option>
                                                                            {cities.map((option, index) => (
                                        <option key={index} value={option.code_city}>{option.fr_Name}</option>
                                        ))}
                                    </select> */}
                    {errors.ville && (
                      <p className="text-red-500">{errors.ville}</p>
                    )}
                  </div>
                  {/* Lieu */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>
                        {t("Lieu")} <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <input
                      defaultValue={address.Adresses}
                      type="text"
                      name="lieu"
                      onChange={handleInputChange}
                      placeholder="Ex : Cocody, Abidjan, Côte d'ivoire "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.adresse && (
                      <p className="text-red-500">{errors.adresse}</p>
                    )}
                  </div>
                </div>

                <div className="bg-white s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px] rounded-md border-b-8  shadow flex flex-col space-y-3 ">
                  {/* caractéristique de la voiture */}
                  <p className="text-lg font-semibold">
                    {t("Dans votre vehicule")} <span className="text-red-600">*</span>
                  </p>
                  <div className="grid s:grid-cols-2 xs:grid-cols-3 gap-y-8">
                    {/* Climatiseur*/}
                    <div className="flex flex-col space-y-2 ">
                      <div className="flex flex-row items-center ">
                        <WiSnowflakeCold className="text-2xl text-[#fe7f2d]" />
                        <label>{t("Climatiseur")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        <input
                          onChange={handleInputChange}
                          type="radio"
                          name="climatiseur"
                          value="1"
                          checked
                        />
                        <label>{t("Oui")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        <input
                          onChange={handleInputChange}
                          type="radio"
                          name="climatiseur"
                          value="0"
                        />
                        <label>{t("Non")}</label>
                      </div>
                      {errors.clim && (
                        <p className="text-red-500">{errors.clim}</p>
                      )}
                    </div>
                    {/* Wifi  */}
                    <div className="flex flex-col space-y-2 ">
                      <div className="flex flex-row items-center space-x-2">
                        <MdOutlineWifi className="text-xl text-[#fe7f2d]" />
                        <label>{t("Wifi")} </label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        <input
                          onChange={handleInputChange}
                          type="radio"
                          name="wifi"
                          value="1"
                          checked
                        />
                        <label>{t("Oui")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        <input
                          onChange={handleInputChange}
                          type="radio"
                          name="wifi"
                          value="0"
                        />
                        <label>{t("Non")}</label>
                      </div>
                      {errors.wifi && (
                        <p className="text-red-500">{errors.wifi}</p>
                      )}
                    </div>
                    {/* Mini TV */}
                    <div className="flex flex-col space-y-2 ">
                      <div className="flex flex-row items-center space-x-2">
                        <SlScreenDesktop className="text-xl text-[#fe7f2d]" />
                        <label>Mini TV</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        <input
                          onChange={handleInputChange}
                          type="radio"
                          name="TV"
                          value="1"
                          checked
                        />
                        <label>{t("Oui")}</label>
                      </div>
                      <div className="flex flex-row items-center space-x-2">
                        <input
                          onChange={handleInputChange}
                          type="radio"
                          name="TV"
                          value="0"
                        />
                        <label>{t("Non")}</label>
                      </div>
                      {errors.camera && (
                        <p className="text-red-500">{errors.camera}</p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="bg-white s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px] rounded-md border-b-8  shadow flex flex-col space-y-3 ">
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <CiCalendarDate className=" text-[#fe7f2d]" />
                      <label>
                        {t("Date de disponibilité")}{" "}
                        <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <input
                      name="date"
                      onChange={handleInputChange}
                      type="date"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.date && (
                      <p className="text-red-500">{errors.date}</p>
                    )}
                  </div>
                  {/* Kilométrage du véhicule */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <RxDimensions className=" text-[#fe7f2d]" />
                      <label>
                        {t("Kilométrage du véhicule")}{" "}
                        <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <input
                      type="number"
                      onChange={handleInputChange}
                      name="km"
                      placeholder="Ex : 10 "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.size && (
                      <p className="text-red-500">{errors.size}</p>
                    )}
                  </div>
                  {/* Nombre de place */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <FaUser className=" text-[#fe7f2d]" />
                      <label>
                        {t("Nombre de place")} <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <input
                      type="number"
                      name="nbre"
                      onChange={handleInputChange}
                      placeholder="Ex : 5"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.place && (
                      <p className="text-red-500">{errors.place}</p>
                    )}
                  </div>
                  {/* Puissance du véhicule */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlineRoomPreferences className=" text-[#fe7f2d]" />
                      <label>
                        {t("Puissance du véhicule")}{" "}
                        <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <input
                      type="number"
                      name="chevaux"
                      onChange={handleInputChange}
                      placeholder="Ex : 10 "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.puissance && (
                      <p className="text-red-500">{errors.puissance}</p>
                    )}
                  </div>
                  {/* Tarif */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <GiMoneyStack className="text-xl text-[#fe7f2d]" />
                      <label>
                        {t("Tarif")} <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <input
                      type="number"
                      name="prix"
                      onChange={handleInputChange}
                      placeholder="Ex : 70000 "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.prix && (
                      <p className="text-red-500">{errors.prix}</p>
                    )}
                    <small>{t("Le tarif doit être par jours")}</small>
                  </div>
                  {/* Description */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <AiOutlineEdit className="text-xl text-[#fe7f2d]" />
                      <label>
                        {t("Description du véhicule")}{" "}
                        <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <textarea
                      onChange={handleInputChange}
                      name="msg"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] rounded p-2 h-[200px]"
                    ></textarea>
                    {errors.desc && (
                      <p className="text-red-500">{errors.desc}</p>
                    )}
                  </div>
                </div>

                <div className="bg-white s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px] rounded-md border-b-8  shadow flex flex-col space-y-3 ">
                  {/* date debut */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <CiCalendarDate className=" text-[#fe7f2d]" />
                      <label>
                        {t("Date de debut affichage")}{" "}
                        <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <input
                      name="date_debut"
                      onChange={handleInputChange}
                      type="date"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                      min={today}
                    />
                    {errors.date_debut && (
                      <p className="text-red-500">{errors.date_debut}</p>
                    )}
                  </div>

                  {/* date fin */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <CiCalendarDate className=" text-[#fe7f2d]" />
                      <label>
                        {t("Date de fin affichage")}{" "}
                        <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <input
                      name="date_fin"
                      onChange={handleInputChange}
                      type="date"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                      min={today}
                    />
                    {errors.date_fin && (
                      <p className="text-red-500">{errors.date_fin}</p>
                    )}
                  </div>

                  {totalPaid !== 0 && !isNaN(totalPaid) && (
                      <div className="flex flex-col items-center mx-2 space-y-3 text-center ">
                        <div className="flex flex-row items-center space-x-2 bg-[#1F2937] h-10 rounded">
                          <GiMoneyStack className="text-xl text-white" />
                          <label className="text-white w-[250px] text-bold">
                            {t("Montant total")}: {totalPaid} F CFA
                          </label>
                        </div>
                      </div>
                    )}
                </div>
                { (totalPaid !== 0 && !isNaN(totalPaid)) ? (
                  <button
                    className="bg-[#FCCA46] w-[250px] h-10 rounded
                     text-white"
                  >
                    {t("Procéder au paiement")}
                  </button>
                ) : (
                  <button
                    className="bg-[#FCCA46] w-[150px] h-14 rounded
                     text-white"
                  >
                    {totalPaid === 0 ? t("Ajouter gratuitement") : t("Ajouter")}{" "}
                  </button>
                )}
                {/* <button className='bg-[#FCCA46] w-[150px] h-10 rounded text-white'>Ajouter</button> */}
              </form>

               {
                    open && (
                    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
                        <div className="bg-white rounded-lg p-6 w-full max-w-3xl relative max-h-screen overflow-y-auto">
                            {/* Bouton de fermeture à l'intérieur du modal */}
                            <button
                            onClick={() => setOpen(false)}
                            className="absolute top-3 right-3 text-red-500 text-2xl"
                        >
                            &times;
                        </button>
                            <Create item="Rechargement de la carte AZ"  options={options} onSuccess={submitForm} ></Create>
                        </div>
                    </div>
                    )
                }

            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default AjoutVehicule;
